// extracted by mini-css-extract-plugin
export default {"select-option-row":"BusinessRisks_select-option-row__4jpOe","submitWrapper":"BusinessRisks_submitWrapper__B-wPE"};